/* Provide a text area to write and submit sends. It turns out textarea is tricky in React. */

import React, { Component } from "react";

class SendWrite extends Component {

    handleSendSubmit(currentsenduser, post){
        this.props.pwPostSend(currentsenduser, post);
    }

    handleSendPostChange(event){
       this.props.pwUpdatePostData(event.target.value);
    }
 
    render() {
        if(this.props.currentsenduser){ return(
            <div class="writeanovelform">
            <form>
                <label>
                Send a message to {this.props.currentsenduser}:
                <textarea name="thearea" onChange={this.handleSendPostChange.bind(this)} value={this.props.postData} rows="4"></textarea>
                </label>
                <input type="button" class="button" value="Send" onClick={this.handleSendSubmit.bind(this, this.props.currentsenduser, this.props.postData)} />
              </form>
            </div>
        )}
    else{
        return null;
    }
}
            
}

export default SendWrite


// WEBPACK FOOTER //
// ./src/SendWrite.js